import {ref, Ref} from "vue"

const isPasswordIncorrect: Ref<boolean> = ref(false)

export default isPasswordIncorrect